import { v4 as uuidv4 } from "uuid";

export const setCookie = (
  cname: string,
  data: string | object,
  { expireDays = 1, parseJson = false } = {}
) => {
  const d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${
    parseJson ? JSON.stringify(data) : data
  };${expires};path=/cancellation-service`;
};

export const getCookie = (cname: string): string => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trimStart();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const clearCookie = (cname) => {
  document.cookie = cname + "=; Max-Age=-99999999;path=/cancellation-service;";
};

export function getFolderName() {
  let foldername: string = getCookie("cancellation_foldername").toString();
  if (!foldername) {
    const uuid = uuidv4();
    const numericPart = uuid.replace(/-/g, "").slice(0, 15);
    foldername = `cancellation-${parseInt(numericPart, 16).toString()}`;
    setCookie("cancellation_foldername", foldername);
  }
  return foldername;
}
